import { updates } from '@/mocks/homeData';

export default function Updates() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10 md:mb-14">
          <div className="relative">
            <div className="w-3 h-3 rounded-full bg-primary-500 animate-pulse"></div>
            <div className="absolute inset-0 w-3 h-3 rounded-full bg-primary-500 animate-ping opacity-30"></div>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            最新快讯
          </h2>
          <span className="text-xs text-foreground-500 font-label mt-1">实时滚动更新</span>
        </div>

        <div className="relative pl-8 md:pl-10 border-l-2 border-primary-200/60">
          {updates.map((item, i) => (
            <div
              key={i}
              className={`relative pb-8 md:pb-10 ${i === updates.length - 1 ? 'pb-0' : ''}`}
            >
              <div className="absolute left-[-34px] md:left-[-42px] top-0.5 w-4 h-4 rounded-full border-2 border-primary-500 bg-background-50"></div>
              <div className="flex flex-col gap-1.5">
                <span className="text-xs text-primary-500 font-semibold font-label">{item.time}</span>
                <a
                  href={item.href}
                  className="text-sm md:text-base text-foreground-700 hover:text-primary-500 transition-colors duration-200 font-body leading-relaxed cursor-pointer no-underline"
                >
                  {item.content}
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}